import { render, staticRenderFns } from "./UiTagInput.vue?vue&type=template&id=e55eff42&"
import script from "./UiTagInput.vue?vue&type=script&lang=js&"
export * from "./UiTagInput.vue?vue&type=script&lang=js&"
import style0 from "./UiTagInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports